<script>
import { authMethods, authComputed, profileMethods, profileComputed } from "@/state/helpers";
import { Storage } from 'aws-amplify';

import i18n from "../i18n";
import AccountCreationUnavailableModal from '@/components/AccountCreationUnavailableModal.vue';

/**
 * Topbar component
 */
export default {
  data () {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/germany.jpg"),
          language: "de",
          title: "German",
        },
        {
          flag: require("@/assets/images/flags/italy.jpg"),
          language: "it",
          title: "Italian",
        },
        {
          flag: require("@/assets/images/flags/russia.jpg"),
          language: "ru",
          title: "Russian",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      profilePicture: require('@/assets/images/img-profile-placeholder.png')
    }
  },
  computed: {
    ...authComputed,
    ...profileComputed,
    navHomeAboutRootUrl() {
      if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_NAV_HOMEABOUT_ROOT_URL) {
        return process.env.VUE_APP_NAV_HOMEABOUT_ROOT_URL;
      }
      return '/';
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    layoutscroll: {
      type: Boolean,
      required: true,
    },
  },
  async mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

    if(this.loggedIn){
      this.fetchUserProfilePicture().then(async data => {
        this.profilePicture = (data.profileKey.length == 0 || data.profileKey == null) ? require('@/assets/images/img-profile-placeholder.png') :  await Storage.get(data.profileKey, { level: "protected" });
      })
      .catch(err => console.log(err));
    }
  },
  methods: {
    ...profileMethods,
    ...authMethods,
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    logout() {
      this.logOut();
    },
    toggleMenu() {
      document.getElementsByClassName('wallet-container')[0].classList.remove("hidden");
      document.getElementsByClassName('wallet-link')[0].classList.add("hidden");
      this.$parent.toggleMenu();
    },
    showAccountUnavailable() {
      if (this.$refs && this.$refs.accountModal && typeof this.$refs.accountModal.show === 'function') {
        this.$refs.accountModal.show();
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
  },
  components: {
    AccountCreationUnavailableModal,
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    layoutscroll: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case false:
              document.body.setAttribute("data-layout-scrollable", "false");
              break;
            case true:
              document.body.setAttribute("data-layout-scrollable", "true");
              break;
            default:
              document.body.setAttribute("data-layout-scrollable", "false");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <div class="navbar-header m-0">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a :href="navHomeAboutRootUrl" class="logo logo-dark">
          <span class="logo-sm">
            <img src="@/assets/images/Kanto-Ads-logo-icon.svg" alt="" height="54" />
          </span>
          <span class="logo-lg">
            <img src="@/assets/images/Kanto-Ads-logo.svg" alt="" height="54" />
          </span>
        </a>

        <a :href="navHomeAboutRootUrl" class="logo logo-light">
          <span class="logo-sm">
            <img src="@/assets/images/Kanto-Ads-logo-icon.svg" alt="" height="22" />
          </span>
          <span class="logo-lg">
            <img src="@/assets/images/Kanto-Ads-logo.svg" alt="" height="22" />
          </span>
        </a>
      </div>

      <button
        v-if="loggedIn"
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
        @click="toggleMenu"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <!-- If authenticated -->
    <div class="d-flex" v-if="loggedIn">
      <b-dropdown
        v-if="false"
        toggle-class="header-item noti-icon"
        right
        variant="white"
        menu-class="dropdown-menu-lg dropdown-menu-end p-0"
      >
        <template v-slot:button-content>
          <feather type="bell" class="icon-sm"></feather>
          <span class="noti-dot bg-danger"></span>
        </template>
        <div class="p-3">
          <div class="row align-items-center">
            <div class="col">
              <h5 class="m-0 font-size-15">
                {{ $t("header.notifications.title") }}
              </h5>
            </div>
            <div class="col-auto">
              <a href="#!" class="small">
                {{ $t("header.notifications.view_all") }}</a
              >
            </div>
          </div>
        </div>
        <div data-simplebar style="max-height: 250px;">
          <h6 class="dropdown-header bg-light">
            {{ $t("header.notifications.new") }}
          </h6>
          <a href="javascript:void(0);" class="text-reset notification-item">
            <div class="d-flex border-bottom align-items-start">
              <div class="flex-shrink-0">
                <img
                  :src="profilePicture"
                  class="me-3 rounded-circle avatar-sm"
                  alt="user-pic"
                />
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1">
                  {{ $t("header.notifications.first.title") }}
                </h6>
                <div class="text-muted">
                  <p class="mb-1 font-size-13">
                    {{ $t("header.notifications.first.text") }}
                  </p>
                  <p class="mb-0 font-size-10 text-uppercase fw-bold">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ $t("header.notifications.first.time") }}
                  </p>
                </div>
              </div>
            </div>
          </a>
          <a href="javascript:void(0);" class="text-reset notification-item">
            <div class="d-flex border-bottom align-items-start">
              <div class="flex-shrink-0">
                <div class="avatar-sm me-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="uil-shopping-basket"></i>
                  </span>
                </div>
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1">
                  {{ $t("header.notifications.second.title") }}
                </h6>
                <div class="text-muted">
                  <p class="mb-1 font-size-13">
                    {{ $t("header.notifications.second.text") }}
                  </p>
                  <p class="mb-0 font-size-10 text-uppercase fw-bold">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ $t("header.notifications.second.time") }}
                  </p>
                </div>
              </div>
            </div>
          </a>
          <h6 class="dropdown-header bg-light">
            {{ $t("header.notifications.earlier") }}
          </h6>
          <a href="javascript:void(0);" class="text-reset notification-item">
            <div class="d-flex border-bottom align-items-start">
              <div class="flex-shrink-0">
                <div class="avatar-sm me-3">
                  <span
                    class="avatar-title bg-soft-success text-success rounded-circle font-size-16"
                  >
                    <i class="uil-truck"></i>
                  </span>
                </div>
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1">
                  {{ $t("header.notifications.third.title") }}
                </h6>
                <div class="text-muted">
                  <p class="mb-1 font-size-13">
                    {{ $t("header.notifications.third.text") }}
                  </p>
                  <p class="mb-0 font-size-10 text-uppercase fw-bold">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ $t("header.notifications.third.time") }}
                  </p>
                </div>
              </div>
            </div>
          </a>

          <a href="javascript:void(0);" class="text-reset notification-item">
            <div class="d-flex border-bottom align-items-start">
              <div class="flex-shrink-0">
                <img
                  src="@/assets/images/users/avatar-4.jpg"
                  class="me-3 rounded-circle avatar-sm"
                  alt="user-pic"
                />
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1">
                  {{ $t("header.notifications.four.title") }}
                </h6>
                <div class="text-muted">
                  <p class="mb-1 font-size-13">
                    {{ $t("header.notifications.four.text") }}
                  </p>
                  <p class="mb-0 font-size-10 text-uppercase fw-bold">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ $t("header.notifications.four.time") }}
                  </p>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="p-2 border-top d-grid">
          <a
            class="btn btn-sm btn-link font-size-14 btn-block text-center"
            href="javascript:void(0)"
          >
            <i class="uil-arrow-circle-right me-1"></i>
            <span>{{ $t("header.notifications.load_more") }}</span>
          </a>
        </div>
      </b-dropdown>

      <b-dropdown
        variant="white"
        right
        toggle-class="header-item user text-start d-flex align-items-center"
        class="dropdown d-inline-block"
        menu-class="dropdown-menu-end pt-0"
      >
        <template v-slot:button-content>
          <img
            class="rounded-circle header-profile-user"
            :src="profilePicture"
            alt="Header Avatar"
          />
          <span class="ms-2 d-none d-sm-block user-item-desc">
            <span class="user-name">{{currentUser.name}}</span>
            <span class="user-sub-title"></span>
          </span>
        </template>

        <div class="p-3 bg-details border-bottom">
          <div class="d-flex flex-column">
            <p class="mb-1 font-size-12 fw-semibold">
              <span class="mdi mdi-email-outline font-size-20 mx-2 text-black"></span>
              <span class="d-inline-block text-truncate text-black" style="max-width: calc(100% - 45px);">
                {{ currentUser.email }}
              </span>
            </p>
            <p class="mb-0 font-size-12 fw-semibold">
              <span class="mdi mdi-card-account-phone font-size-17 mx-2 text-black"></span>
              <span class="d-inline-block text-truncate text-black" style="max-width: calc(100% - 45px);">
                {{ currentUser.mobile == '' ?  '--' : currentUser.mobile ?? '--'  }}
              </span>
            </p>
          </div>
        </div>


        <router-link class="dropdown-item" to="/pages/profile" exact-active-class="active"
          ><i
            class="mdi mdi-account-circle text-muted font-size-20 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.profile' )}}</span></router-link
        >
        <!-- <router-link class="dropdown-item" to="/apps/chat"
          ><i
            class="mdi mdi-message-text-outline text-muted font-size-16 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.message' )}}</span></router-link
        >
        <router-link class="dropdown-item" to="/kanban-board"
          ><i
            class="mdi mdi-calendar-check-outline text-muted font-size-16 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.taskboard' )}}</span></router-link
        >
        <router-link class="dropdown-item" to="/pages/faqs"
          ><i
            class="mdi mdi-lifebuoy text-muted font-size-16 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.help' )}}</span></router-link
        >
        <b-dropdown-divider></b-dropdown-divider>
        <router-link class="dropdown-item" to="/pages/profile"
          ><i
            class="mdi mdi-wallet text-muted font-size-16 align-middle me-1"
          ></i>
          <span class="align-middle"
            >{{ $t('header.profilewidget.balance') }} : <b>$6951.02</b></span
          ></router-link
        >
        <router-link
          class="dropdown-item d-flex align-items-center"
          to="/user/settings"
          ><i
            class="mdi mdi-cog-outline text-muted font-size-16 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.settings') }}</span
          ><span class="badge badge-soft-success ms-auto"
            >New</span
          ></router-link
        >
        <router-link class="dropdown-item" to="/auth/lockscreen-basic"
          ><i
            class="mdi mdi-lock text-muted font-size-16 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.lockscreen') }}</span></router-link
        > -->
        <a class="dropdown-item" href="javascript:void(0);" @click="logout()"
          ><i
            class="mdi mdi-logout text-muted font-size-20 align-middle me-1"
          ></i>
          <span class="align-middle">{{ $t('header.profilewidget.logout') }}</span></a
        >
      </b-dropdown>
    </div>
    <!-- End authenticated -->

    <!-- If not authenticated -->
    <div class="d-flex h-100 nav-links" v-if="!loggedIn">
      <div class="h-100 topbar-link ms-4 me-4 d-flex" ><span class="align-self-center"><a :href="navHomeAboutRootUrl">Home</a></span></div>
      <!-- <div class="h-100 topbar-link ms-4 me-4 d-flex browse-space-link" ><span class="align-self-center"><a :href="process.env.VUE_APP_NAV_HOMEABOUT_ROOT_URL + '#browse-space'">Browse Available Space</a></span></div> -->
      <!-- <div class="h-100 topbar-link ms-4 me-4 mobile-browse-space-link" ><span class="align-self-center"><a :href="process.env.VUE_APP_NAV_HOMEABOUT_ROOT_URL + '#browse-space'">Browse Space</a></span></div> -->
      <div class="h-100 topbar-link ms-4 me-4 d-flex" ><span class="align-self-center"><a :href="navHomeAboutRootUrl + 'about-us'">About Us</a></span></div>
      <div class="h-100 topbar-link ms-4 me-4 d-flex" :class="{ active: this.$route.name == 'login' }"><router-link class="align-self-center" :to="{name: 'login'}">Login</router-link></div>
      <div class="align-self-center ps-3 separator">
        <b-button class="get-started-btn" variant="primary" @click="showAccountUnavailable">Get Started</b-button>
      </div>
    </div>
    <account-creation-unavailable-modal ref="accountModal" />
    
    <!-- End authenticated -->
  </div>
</template>


<style scoped>
  .navbar-header {
    max-width: 100% !important;
  }
  
  .separator {
    border-left: solid 1px #e1e1e1;
  }

  @media (max-width: 768px) { 
    .topbar-link {
      /* display: none !important; */
      margin-left: 10px !important;
      margin-right: 10px !important;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    .navbar-brand-box {
      padding: 0px 8px !important;
    }
    .navbar-brand-box .logo-sm img {
      width: 30px !important;
    }

    .nav-links {
      font-size: 11px !important;
    }

    .get-started-btn {
      font-size: 11px;
      padding: 0px 4px;
    }

    .topbar-link {
      margin-left: 5px !important;
      margin-right: 5px !important;
    }

    .separator {
      padding-left: 7px !important;
    }

    .browse-space-link{
      display: none !important;
    }

    .mobile-browse-space-link {
      display: flex !important;
    }

    /* .browse-space-link:after{
      content: 'Browse Space' !important;
    } */
  }

  .bg-details {
    background-color: #f2f1f7 !important;
  }  

  .topbar-link span, .topbar-link a {
    color: #AFAFAF;
  }

  .topbar-link .router-link-exact-active {
    color: #F84B04;
  }
  .topbar-link.active {
    color: #000;
    border-bottom: solid 3px #F84B04;
  }
  .c-not-allowed{
    cursor: not-allowed;
  }

  .mobile-browse-space-link {
    display: none;
  }
</style>